import React, { memo, useState } from 'react';
import styles from './listDevices.module.scss';
import ListContainer from '../../../../../shared/components/ListContainer';
import SVG from 'react-inlinesvg';
import { useHistory } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import {  launchSVG } from '../../../../../shared/helpers/icons';

const getStatusClass = (status, styles) => {
    if (!status) {
        return styles['Bodega-dispositivos'];
    }
    
    const statusMap = {
        'activo': 'Asignado-a-gps',
        'asignado a gps': 'Asignado-a-gps',
        'bodega dispositivos': 'Bodega-dispositivos',
        'terreno': 'Terreno',
        'bodega-dispositivos': 'Bodega-dispositivos',
        'baja': 'Baja'
    };
    
    try {
        return styles[statusMap[status.toLowerCase()] || 'Bodega-dispositivos'];
    } catch (error) {
        return styles['Bodega-dispositivos'];
    }
};

const ListDevices = ({
    devices,
    fetching,
    setDeviceSelected,
    submitSuccess,
    totalItems,
    fetchingMoreItems,
    onScrollBottomAction,
    enableCheckboxes = false,
    selectedRows = [],
    onSelectRow = () => {},
    getGpsDevicesRequest,
    gps,
}) => {
    const history = useHistory();
    const [pendingImei, setPendingImei] = useState(null);

    const handleGotoGps = (imei, e) => {
        e.stopPropagation();
        setPendingImei(imei);
        
        if (getGpsDevicesRequest) {
            getGpsDevicesRequest({ search: imei });
        }
    };
    
    /* Comentando la lógica del modal
    const [isOpenDialog, setIsOpenDialog] = useState(false);

    const handleOpenDialog = device => {
        setDeviceSelected(device);
        setIsOpenDialog(true);
    };

    const handleCloseDialog = useCallback(() => {
        setDeviceSelected();
        setIsOpenDialog(false);
    }, [setDeviceSelected]);

    useEffect(() => {
        if (submitSuccess) {
            handleCloseDialog();
        }
    }, [submitSuccess, handleCloseDialog]);
    */

    const handleDeviceClick = (device) => {
        setDeviceSelected(device);
        history.push(`/stock/devices/${device.imei}`);
    };

    function formatDate(fecha) {
        const date = new Date(fecha);
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0'); 
        const anio = date.getFullYear();
        return `${dia}-${mes}-${anio}`;
      }

    return (
        <>
            <ListContainer
                skeletonColumn={6}
                loading={fetching}
                totalItems={totalItems}
                fetchingMoreItems={fetchingMoreItems}
                onScrollBottomAction={onScrollBottomAction}
            >
                {devices.map(device => (
                    <div key={device._id} onClick={() => handleDeviceClick(device)} style={{ cursor: 'pointer' }} className={styles.row}>
                        {enableCheckboxes && (
                            <div className={styles.checkboxCell} onClick={(e) => e.stopPropagation()}>
                                <input
                                    type="checkbox"
                                    checked={selectedRows.includes(device._id)}
                                    onChange={e => onSelectRow(device._id, e.target.checked)}
                                    onClick={e => e.stopPropagation()}
                                />
                            </div>
                        )}
                        <div> {formatDate(device.created)} </div>
                        <div> {device.imei} </div>
                        <div> {device.provider} </div>
                        <div> {device.model_name || '-'} </div>
                        <div className={styles.statusCell}>
                            {device.status_name ? (
                                <span className={`${styles.status} ${getStatusClass(device.status_name, styles)}`}>
                                    {device.status_name}
                                </span>
                            ) : (
                                <span >-</span>
                            )}
                            {device.status_name && device.status_name.toLowerCase() !== 'baja' && <span className={styles.arrow}>›</span>}
                        </div>
                        <div    className={`${styles.subStatus} ${
        device.status_name?.toLowerCase() !== 'baja' && device.substatus?.value 
            ? getStatusClass(device.status_name, styles)
            : ''
    }`}>
                            {device.status_name?.toLowerCase() === 'baja'
                                ? null
                                : device.substatus?.value || '-'}
                        </div>
                        <div className={styles.textAlignCenter}>
                            <SVG
                                src={device.enabledIcon}
                                className={`${styles.svg} ${device.enabled ? styles.enabled : styles.disabled}`}
                            />
                        </div>
                        <div className={styles.iconColumn}>
                        {device.status_name === "Asignado a GPS" ? (
        <Tooltip title="Ver GPS asignado" placement="bottom">
            <div 
                onClick={(e) => {
                    e.stopPropagation();
                    const imei = device.imei || '';
                    const last8 = imei.slice(-8);
                    history.push(`/stock/gps/${last8}`);
                }}
                className={styles.launchIconWrapper}
            >
                <SVG
                    src={launchSVG}
                    className={styles.launchIcon}
                />
            </div>
        </Tooltip>
    ) : (
        <div></div>
    )}
                        </div>
                    </div>
                ))}
            </ListContainer>
            {/* Comentando el modal
            {isOpenDialog && <FormDevices open={isOpenDialog} onClose={handleCloseDialog} />}
            */}
        </>
    );
};

export default memo(ListDevices);
